module.exports = __webpack_public_path__ + "img/laptop.21353aa4.svg";